import { render, staticRenderFns } from "./World.vue?vue&type=template&id=4ecd335b&scoped=true"
import script from "./World.vue?vue&type=script&lang=js"
export * from "./World.vue?vue&type=script&lang=js"
import style0 from "./World.vue?vue&type=style&index=0&id=4ecd335b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecd335b",
  null
  
)

export default component.exports